import axios from "axios";
import { ApiServices } from "../service/apiServices";

export const getLycaUserCountSim = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaUserCountSims');
  return result;
};

export const getLycaRevenueCostSims = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaRevenueCostSims');
  return result;
};

export const getLycaTotalRevenueRechargeTyp = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaTotalRevenueRechargeTyp');
  return result;
};

export const getLycaMothwiseTotalBundleCost = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaMothwiseTotalBundleCost');
  return result;
};

export const getLycaPercentageContribution = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaPercentageContribution');
  return result;
};


export const getLycaCountEachChannelCategory = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaCountEachChannelCategory');
  return result;
};

export const getLycaDistributionRfm = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaDistributionRfm');
  return result;
};

export const getLycaDistributionCvlSegement = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaDistributionCvlSegement');
  console.log('result---', result)
  return result;
};

export const getLycaDistributionNboSegement = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaDistributionNboSegement');
  return result;
};

export const getLycaTotalRevenuePerCustomer = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaTotalRevenuePerCustomer');
  return result;
};

export const getLycaSegementationTargetExperience = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaSegementationTargetExperience');
  return result;
};

export const getLycaSegementationBasedOnCustomer = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaSegementationBasedOnCustomer');
  return result;
};

export const getLycaSegementationDistributionChart = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaSegementationDistributionChart');
  return result;
};

export const getLycaChurnPredictionOverallRlt = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaChurnPredictionOverallRlt');
  return result;
};

export const getLycaChurnPredictionProbability = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaChurnPredictionProbability');
  return result;
};

export const getLycaChurnPredictionSegmentRlt = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getLycaChurnPredictionSegmentRlt');
  return result;
};

export const getLycaRecommentationDtl = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getLycaRecommentationDtl');
  return result;
};

export const cvm_user_login = async (body: { email_id?: string; is_login?: number }) => {
  const result = await ApiServices.post(body, '/cvm_user_login');
  return result;
};

export const get_user_login = async (body: { email?: string; }) => {
  const result = await ApiServices.post(body,'/get_user_login');
  return result;
};

export const clvSummaryNlpLycaData = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/plots_summary_lyca"
  );
  return response;
};


export const segmentationNlpLycaDatas = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/segmentation_plot_summary_lyca"
  );
  return response;
};

export const buyerPersonLycaNlpData = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/buyer_personna_summary_lyca"
  );
  return response;
};

export const churnPredictionLycaNlpData = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/churn_summary_lyca"
  );
  return response;
};

export const churnPlotLycaNlpData = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/churn_plot_summary_lyca"
  );
  return response;
};

export const orchestrationAgentGoals = async () => {
  const response = await axios.get(
    "https://nlpcampaign.worktual.co.uk/campaign_goal_lyca"
  );
  return response;
}